import React from "react";
import { StyleSheet } from "react-native";

var nextButtonStyle = StyleSheet.create({
    btnNextView: {
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: 10,
        paddingRight: 10,
        width: "100%",
    },
    btnNext: {
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#1E90FF",
        width: "90%",
        height: 40,
        borderRadius: 30,
        marginTop: 13,
        marginBottom: 13,
    },
    btnNextText: {
        color: "#fff",
    },
});

export default nextButtonStyle;
